import { createSelector } from 'reselect';
import get from 'lodash/get';

export const getDocumentManagementTableView = state => state.document_management;

export const getDocumentManagementTableExcludedCols = createSelector(getDocumentManagementTableView, data => get(data, 'documentManagementTableExcludedCols'));



// WEBPACK FOOTER //
// ./src/reducers/document_management/selectors.js